/** @param {(key: string) => string} tk — scoped translate e.g. (k) => t(`manageNews.${k}`) */
export function getNewsFields(tk) {
  return [
    {
      name: "title_ar",
      label: tk("fields.titleAr"),
      type: "text",
      required: true,
    },
    {
      name: "title_en",
      label: tk("fields.titleEn"),
      type: "text",
      required: true,
    },
    {
      name: "content_ar",
      label: tk("fields.contentAr"),
      type: "textarea",
      rows: 5,
    },
    {
      name: "content_en",
      label: tk("fields.contentEn"),
      type: "textarea",
      rows: 5,
    },
    {
      name: "image",
      label: tk("fields.image"),
      type: "file",
      required: false,
      maxFileMB: 2,
      hint: tk("hints.image"),
    },
  ];
}
